import React from 'react';
import styled from '@emotion/styled';
import { Box, Flex, FlexProps } from 'rebass';
import { Accept, DropzoneState } from 'react-dropzone';
import Icon, { IconType } from '../Icon/Icon';
import colors from '../../theme/colors';

const getColor = (props: any) => {
  if (props.isDragAccept) {
    return colors.statusGreen;
  }
  if (props.isDragReject) {
    return colors.statusError;
  }
  if (props.isFocused) {
    return colors.statusBlue;
  }
  return '#cccccc';
};

const getTextColor = (props: any) => {
  if (props.isDragAccept || props.isDragReject || props.isFocused) {
    return getColor(props);
  }
  return '#aaa';
};

const DropFlex = styled(Flex)<FlexProps>`
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding: 20px;
  border-width: 3px;
  border-radius: 10px;
  border-style: dashed;
  border-color: ${(props) => getColor(props)};
  background-color: ${(props) => getColor(props)}22;
  color: ${(props) => getTextColor(props)};
  outline: none;
  transition: border 0.24s ease-in-out;
  p {
    font-weight: bold;
    padding-bottom: 0;
    margin-bottom: 0;
  }
  * {
    pointer-events: none;
  }
`;

type UploadDropProps = Omit<FlexProps, 'accept'> & {
  multiple?: boolean;
  accept?: Accept;
  icon?: IconType;
  dropZone: DropzoneState;
};

const printAccept = (accept: Accept): string | undefined => {
  if (!accept) {
    return;
  }
  return Object.keys(accept)
    .reduce((parts, key) => {
      parts.push(
        accept[key]
          .filter((extension) => extension.toLowerCase() !== '.jpeg')
          .join(', ')
      );
      return parts;
    }, [] as string[])
    .join(', ');
};

const UploadDrop: React.FC<UploadDropProps> = ({
  multiple,
  accept,
  icon,
  dropZone: {
    getRootProps,
    isFocused,
    isDragAccept,
    isDragReject,
    getInputProps,
  },
  ...flexProps
}) => {
  let children = Array.isArray(flexProps.children)
    ? flexProps.children.filter((child) => !!child)
    : flexProps.children;

  if (Array.isArray(children) && children.length === 0) {
    children = undefined;
  }

  return (
    <>
      <DropFlex
        {...getRootProps({
          bg: 'primary',
          isFocused,
          isDragAccept,
          isDragReject,
          ...(flexProps as any),
        })}
      >
        <input {...getInputProps()} />
        {!children && <Icon size="100" icon={icon ?? 'file'} />}
        {children}
        <p>drag 'n' drop or click to select file{multiple ? 's' : ''}</p>
        {accept && <Box fontSize={1}>{printAccept(accept)}</Box>}
      </DropFlex>
    </>
  );
};

export default UploadDrop;
